// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c08c1da","455":"f2bd47d1","977":"970d296e"}[chunkId] + ".chunk.js";
};